module.exports = __webpack_public_path__ + "static/media/red-pill.af273b14.png";